/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Brew_Steep_TimeInputs */

const vi_shop_brew_steep_time = /** @type {(inputs: Shop_Brew_Steep_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian hãm`)
};

/**

* @param {Shop_Brew_Steep_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_brew_steep_time = /** @type {((inputs?: Shop_Brew_Steep_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Brew_Steep_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_brew_steep_time(inputs)
});